/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

import { withStyles } from "@material-ui/core/styles";
// import { useTheme } from '@material-ui/styles';

import { List, TextField, FunctionField, EditButton, DeleteButton, ShowButton, CreateButton } from "jazasoft";

import Datagrid from "../../../components/Datagrid";
import { useEntityPrivilege } from "../../../hooks";
import hasPrivilege from "../../../utils/hasPrivilege";
import { ResourceId, Scope } from "../../../utils/privilege";
import { AlertParemeter as Parameter } from "../../../utils/types";

const paramMap = Object.values(Parameter).reduce((acc, e) => ({ ...acc, [e.id]: e.name }), {});

const homeStyle = theme => ({
  buttonEdit: {
    width: theme.spacing(14)
  },
  buttonDelete: {
    width: theme.spacing(16)
  },
  headerCell: {
    padding: "12px",
    fontSize: 12,
    fontWeight: "bold",
    color: "#333333",
    textTransform: "uppercase",
    "&:last-child": {
      padding: "12px",
      fontSize: 10,
      fontWeight: "bold",
      color: "#333333",
      textTransform: "uppercase"
    }
  },
  rowCell: {
    padding: "8px 12px",
    fontSize: 12,
    "&:last-child": {
      padding: "8px 12px",
      fontSize: 10
    }
  },
  buttonHistory: {
    width: theme.spacing(1)
  }
});

const AlertParameterHome = withStyles(homeStyle)(({ classes, theme, ...props }) => {
  const { roles, hasAccess } = props;
  const { disableCreate, disableEdit, disableDelete } = useEntityPrivilege("alertReason");
  return (
    <List
      actions={({ basePath }) => (
        <div>
          {hasPrivilege(roles, hasAccess, ResourceId.ALERT_PARAMETER, Scope.WRITE) && !disableCreate && (
            <CreateButton basePath={basePath} showLabel={false} />
          )}
        </div>
      )}
      searchKeys={["desc"]}
      {...props}>
      <Datagrid classes={{ headerCell: classes.headerCell, rowCell: classes.rowCell }}>
        <FunctionField source="parameter" render={record => paramMap[record.parameter]} />
        <TextField source="desc" />
        <FunctionField source="minusTolerance" render={record => `${record.minusTolerance || "-"} ${record.toleranceUnit || ""}`} />
        <FunctionField source="plusTolerance" render={record => `${record.plusTolerance || "-"} ${record.toleranceUnit || ""}`} />
        <ShowButton cellClassName={classes.button} />
        {hasPrivilege(roles, hasAccess, ResourceId.ALERT_PARAMETER, Scope.UPDATE) && !disableEdit && (
          <EditButton cellClassName={classes.buttonEdit} />
        )}
        {hasPrivilege(roles, hasAccess, ResourceId.ALERT_PARAMETER, Scope.DELETE) && !disableDelete && (
          <DeleteButton cellClassName={classes.buttonDelete} />
        )}
      </Datagrid>
    </List>
  );
});

export default AlertParameterHome;
